import EnterpriseIcon, { ChevronUpIcon, ChevronDownIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default from 'react';
import TooltipHeader from '../TooltipHeader.js';
import { SET_COLUMN } from '../utils/constants.js';
import { useTable } from '../utils/hooks.js';

var SortableHeader = function SortableHeader(_ref) {
  var children = _ref.children,
    column = _ref.column,
    columnClasses = _ref.columnClasses,
    columnText = _ref.columnText,
    columnTextId = _ref.columnTextId,
    tooltipText = _ref.tooltipText,
    style = _ref.style;
  var _useTable = useTable(),
    dispatch = _useTable.dispatch,
    _useTable$state = _useTable.state,
    dataTestId = _useTable$state.dataTestId,
    isServer = _useTable$state.isServer;
  var shouldSort = column.shouldSort,
    sortDirection = column.sortDirection,
    sortType = column.sortType,
    onSort = column.onSort,
    field = column.field;
  var hasActiveSort = shouldSort && field === column.field;
  var handleSort = function handleSort(sortField, sortDirection, sortType, onSort) {
    dispatch({
      payload: {
        field: sortField,
        sortDirection: sortDirection,
        sortType: sortType
      },
      type: SET_COLUMN
    });
    if (typeof onSort === 'function' && isServer) {
      onSort(sortDirection, sortField);
    }
  };
  var sortIconClasses = classnames('C-TableSortButton__icon', {
    '--sorted': hasActiveSort && sortDirection
  });
  var handleToggleSort = function handleToggleSort() {
    if (sortDirection === 'asc') {
      handleSort(field, 'dsc', sortType, onSort);
    } else if (sortDirection === 'dsc') {
      handleSort(field, null, sortType, onSort);
    } else if (!sortDirection) {
      handleSort(field, 'asc', sortType, onSort);
    }
  };
  var isCenterAligned = columnClasses.includes('--text-align-center');
  var isRightAligned = columnClasses.includes('--text-align-right');
  var sortButtonContentClasses = classnames('C-TableSortButton__content', {
    '--text-align-center': isCenterAligned,
    '--text-align-left': !(isCenterAligned | isRightAligned),
    '--text-align-right': isRightAligned
  });
  var accessibilityText = function accessibilityText() {
    if (sortDirection === 'asc') {
      if (hasActiveSort) {
        return "".concat(columnText, ": sorted ascending, click to sort descending");
      } else {
        return "".concat(columnText, ": unsorted column, click to sort descending");
      }
    } else if (sortDirection === 'dsc') {
      if (hasActiveSort) {
        return "".concat(columnText, ": sorted descending, click to remove sort");
      } else {
        return "".concat(columnText, ": unsorted column, click to remove sort");
      }
    } else {
      return "".concat(columnText, ": unsorted column, click to sort ascending");
    }
  };
  return /*#__PURE__*/React__default.createElement("th", {
    key: "headerButton-".concat(field),
    className: columnClasses,
    scope: "col",
    role: "columnheader",
    style: style
  }, /*#__PURE__*/React__default.createElement("button", {
    "aria-label": accessibilityText(),
    "aria-live": "polite",
    "data-testid": dataTestId ? "".concat(dataTestId, "-header-").concat(field) : null,
    onClick: handleToggleSort,
    className: "C-TableSortButton C-HeaderCell__cellOverflow"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: sortButtonContentClasses
  }, /*#__PURE__*/React__default.createElement(TooltipHeader, {
    headerText: columnText,
    tooltipText: tooltipText,
    columnTextId: columnTextId
  }), /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    icon: sortDirection === 'asc' ? ChevronUpIcon : ChevronDownIcon,
    className: sortIconClasses
  }))), children);
};

export { SortableHeader, SortableHeader as default };
